import { useEffect } from 'react';
import { ProductColor } from '../../../integrations/relewise/types/mapped';

export const useBuyboxQuerySetter = (selectedColor: ProductColor | undefined, selectedSize: string | undefined) => {
    useEffect(() => {
        const url = new URL(window.location.href);
        if (selectedColor) {
            url.searchParams.set('color', selectedColor.name);
        } else {
            url.searchParams.delete('color');
        }
        if (selectedSize) {
            url.searchParams.set('size', selectedSize);
        } else {
            url.searchParams.delete('size');
        }
        window.history.replaceState({}, '', url.href);
    }, [selectedColor, selectedSize]);
};
